"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _button = require("../button");
var _Banner = _interopRequireDefault(require("./Banner.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Banner = /*#__PURE__*/function (_React$Component) {
  function Banner() {
    _classCallCheck(this, Banner);
    return _callSuper(this, Banner, arguments);
  }
  _inherits(Banner, _React$Component);
  return _createClass(Banner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;
      if (!(0, _utils.isBlank)(this.props.autoHideTime)) {
        this.timeoutReference = setTimeout(function () {
          _this.props.closeTrigger();
        }, this.props.autoHideTime);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeoutReference) {
        clearTimeout(this.timeoutReference);
        this.timeoutReference = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        autoHideTime = _this$props.autoHideTime,
        children = _this$props.children,
        closable = _this$props.closable,
        id = _this$props.id,
        type = _this$props.type,
        className = _this$props.className;
      var icon;
      switch (type) {
        case 'success':
          icon = 'ion-checkmark-circled';
          break;
        case 'error':
          icon = 'ion-close-circled';
          break;
        case 'info':
          icon = 'ion-ios-bell';
          break;
        case 'warning':
        default:
          icon = 'ion-android-alert';
          break;
      }
      return /*#__PURE__*/_react["default"].createElement(_Banner["default"], {
        autoHideTime: autoHideTime,
        closable: closable,
        "data-type": type,
        type: type,
        id: id,
        className: className
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "banner-icon icon",
        icon: icon,
        size: 24
      }), children, closable && /*#__PURE__*/_react["default"].createElement(_button.Button, {
        className: "banner-dismiss-button",
        action: function action() {
          return _this2.props.closeTrigger();
        },
        type: "link"
      }, "Dismiss"));
    }
  }]);
}(_react["default"].Component);
Banner.propTypes = {
  /** Time to display the banner in case it should autohide in miliseconds */
  autoHideTime: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /** Text or html to be displayed inside the banner */
  children: _propTypes["default"].node.isRequired,
  /** Flag to indicate wheather the banner should have a button to close */
  closable: _propTypes["default"].bool,
  /** Html id attribute for the element */
  id: _propTypes["default"].string,
  /** The type of the notification banner (eg. success, error, info) */
  type: _propTypes["default"].oneOf(['success', 'error', 'warning', 'info']).isRequired,
  /** an action to do when closing the banner */
  closeTrigger: _propTypes["default"].func,
  /** Html class attribute for the element */
  className: _propTypes["default"].string
};
Banner.defaultProps = {
  closeTrigger: function closeTrigger() {},
  autoHideTime: undefined,
  id: 'notificationBanner',
  closable: true,
  className: 'notification-banner'
};
var _default = exports["default"] = Banner;